export const colors = [
  '#E14D2A', '#3E6D9C', '#001253',
  '#59C1BD', '#628E90', '#FF7777',
  '#5A8F7B', '#FA7070', '#EB4747',
  '#7C3E66', '#7FB5FF', '#2B4865',
  '#CC9C75', '#B33030', '#EBA83A',
  '#9B3675', '#E08F62', '#42B883'];
